import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useBoundStore from 'store';
import { BuyApartmentFlowPaths } from 'routes';
import useLimitsSecondary from '../../api/hooks/use-limits-secondary';
import { MarketTypes } from '../../api/types';
import { SQ_METER_SIGN } from 'lib/constants';
import AreaInput from 'components/area-input';
import { ButtonProps } from 'components/button';
import BaseScreen from 'components/base-screen';
import MeaningfulHeader from 'components/meaningful-header';
import { formatArea, formatViewObjectsPhrase } from 'lib/utils';
import styles from './styles.module.scss';

const ChooseApartmentSquareSecondary: React.FC = () => {
  const navigate = useNavigate();
  const areaSqFootageRangeMin = useBoundStore((s) => s.areaSqFootageRangeMin);
  const setAreaSqFootageRangeMin = useBoundStore((s) => s.setAreaSqFootageRangeMin);
  const areaSqFootageRangeMax = useBoundStore((s) => s.areaSqFootageRangeMax);
  const setAreaSqFootageRangeMax = useBoundStore((s) => s.setAreaSqFootageRangeMax);
  const [lowerSqFootage, setLowerSqFootage] = useState(areaSqFootageRangeMin);
  const [upperSqFootage, setUpperSqFootage] = useState(areaSqFootageRangeMax);

  const { filterLimits, count, isLoading } = useLimitsSecondary(true, MarketTypes.SECONDARY);

  const buttons: ButtonProps[] = [
    {
      loading: isLoading,
      disabled: isLoading || count === undefined,
      label: isLoading ? 'Загрузка' : formatViewObjectsPhrase(count),
      variant: 'secondary',
      onClick: () => navigate(BuyApartmentFlowPaths.apartmentListBuySecondary),
    },
  ];

  return (
    <BaseScreen
      padContent
      buttons={buttons}
      title='Подбор объектов вторички'
      onBackButtonClick={() => navigate(-1)}
    >
      <div className={styles.container}>
        <MeaningfulHeader
          className={styles.header}
          header={`Общая площадь, ${SQ_METER_SIGN}`}
          motto='Дом - это там, где находится сердце'
        />

        <AreaInput
          clearButton
          value={lowerSqFootage}
          onChange={(value) => {
            const val = Number(value);
            setLowerSqFootage(val);
            setAreaSqFootageRangeMin(val);
          }}
          autoFocus={lowerSqFootage === undefined}
          placeholder={formatArea(filterLimits?.areaMin ?? 0)}
        />
        <AreaInput
          clearButton
          value={upperSqFootage}
          onChange={(value) => {
            const val = Number(value);
            setUpperSqFootage(val);
            setAreaSqFootageRangeMax(val);
          }}
          placeholder={formatArea(filterLimits?.areaMax ?? 0)}
        />
      </div>
    </BaseScreen>
  );
};

export default ChooseApartmentSquareSecondary;
